import { type FeedbackContext } from '../../constants/analytics';

export const getFeedbackCollectorContext = (keys: FeedbackContext) => {
	return JSON.stringify(keys);
};
